import { SOCIAL } from '../theme'
import type { SiteSettings } from '../types'
import { FacebookIcon, InstagramIcon, WhatsAppIcon, YouTubeIcon } from '../components/icons'

export interface SocialLink {
  key: 'instagram' | 'facebook' | 'youtube' | 'whatsapp'
  href: string
  /** Network name, for titles and the footer. */
  label: string
  /** Editable display text (handle / page name), falls back to the label. */
  display: string
  Icon: typeof InstagramIcon
  color: string
  /** Brand fill used by the pills in the Redes section. */
  bg: string
  shadow: string
}

/**
 * The networks the site links to, in display order. A network with no URL in the
 * CMS is omitted everywhere it would otherwise appear.
 */
export function socialLinks(settings: SiteSettings): SocialLink[] {
  const s = settings.social ?? {}

  const all: (SocialLink | null)[] = [
    s.instagram
      ? {
          key: 'instagram',
          href: s.instagram,
          label: 'Instagram',
          display: s.instagramHandle || 'Instagram',
          Icon: InstagramIcon,
          color: SOCIAL.instagram,
          bg: 'linear-gradient(45deg,#f09433,#e6683c,#dc2743,#cc2366,#bc1888)',
          shadow: 'rgba(193,39,45,.28)',
        }
      : null,
    s.facebook
      ? {
          key: 'facebook',
          href: s.facebook,
          label: 'Facebook',
          display: s.facebookLabel || 'Facebook',
          Icon: FacebookIcon,
          color: SOCIAL.facebook,
          bg: '#1877F2',
          shadow: 'rgba(27,79,156,.28)',
        }
      : null,
    s.youtube
      ? {
          key: 'youtube',
          href: s.youtube,
          label: 'YouTube',
          display: 'YouTube',
          Icon: YouTubeIcon,
          color: SOCIAL.youtube,
          bg: '#FF0000',
          shadow: 'rgba(193,39,45,.24)',
        }
      : null,
    s.whatsapp
      ? {
          key: 'whatsapp',
          href: s.whatsapp,
          label: 'WhatsApp',
          display: 'WhatsApp',
          Icon: WhatsAppIcon,
          color: SOCIAL.whatsapp,
          bg: '#25D366',
          shadow: 'rgba(27,79,156,.28)',
        }
      : null,
  ]

  return all.filter((x): x is SocialLink => x !== null)
}
